import styled from "styled-components";
import Button from "./mocks/support/Button";
import OutletMenuHeader from "./mocks/outletMenu/OutletMenuHeader";
import OrderTimeSelectionStep from "./mocks/outlet/OrderTimeSelectionStep";
import AuthProfileSelectionModal from "./mocks/auth/AuthProfileSelectionModal";
import CartItem from "./mocks/orderSummary/CartItem";
import OrderCollectSlider from "./mocks/collectionSlider/OrderCollectSlider";
import Card from "./mocks/card/Card";

const Container = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;

  h4 {
    margin-top: 20px;
    color: black;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin-bottom: 3px;
`;

type WebButtonPreviewsProps = {
  className?: string;
};

export default function WebButtonPreviews({
  className,
}: WebButtonPreviewsProps) {
  return (
    <Container className={className}>
      <StyledButton size="large" variant="primary">
        Primary Button
      </StyledButton>
      <StyledButton size="large" variant="secondary">
        Secondary Button
      </StyledButton>
      <StyledButton size="large" variant="tertiary">
        Tertiary Button
      </StyledButton>

      <h4>Outlet Menu</h4>
      <OutletMenuHeader />

      <h4>Order Time Selection</h4>
      <OrderTimeSelectionStep />

      <h4>Change Profile</h4>
      <AuthProfileSelectionModal />

      <h4>Cart Item</h4>
      <CartItem />

      <h4>Collection slider</h4>
      <Card>
        <OrderCollectSlider />
      </Card>
    </Container>
  );
}
